/**
 * 
 * key
 * 
 */


const key = 'ZXdRdWV1ZVBsYW5uaW5nUmVwb3J0'

export default key 